// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-74e0e3ce]{padding:.5rem;border-radius:.5rem;background-color:#fff;display:flex;flex-wrap:wrap;flex-direction:row}.card[data-v-74e0e3ce]>:first-child{margin-right:1rem;margin-bottom:1rem}@media (max-width:600){.card[data-v-74e0e3ce]{flex-direction:column}.card[data-v-74e0e3ce]>:first-child{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
